export const FETCHED_VIDEOS = 'FETCHED_VIDEOS';
export const SELECTED_VIDEO = 'SELECTED_VIDEO';
export const RECOMMENDED_VIDEO_SELECTED = 'RECOMMENDED_VIDEO_SELECTED';